// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ii-3";
export var downloadButton = "_ii-4";
export var fileContainer = "_ii-9 _ii-7";
export var fileContainerBase = "_ii-7";
export var fileContainerBaseSm = "_ii-a _ii-7";
export var fileContainerFixedHeight = "_ii-8 _ii-7";
export var fileContainerFixedHeightSm = "_ii-c _ii-a _ii-7";
export var fileContainerSm = "_ii-b _ii-a _ii-7";
export var fileInfo = "_ii-5";
export var fileInfoWidthRestricted = "_ii-6";
export var fileType = "_ii-1";
export var fileTypeName = "_ii-2";
export var fileTypeSm = "_ii-d _ii-1";
export var image = "_ii-0";
export var link = "_ii-f";
export var overflowEllipsis = "_ii-e";